import type { ReactNode } from 'react';

interface Props {
  className?: string;
  children?: ReactNode;
}

export default function Skeleton({ className = '', children }: Props) {
  const classes = `ui-skeleton ${className}`.trim();

  return <div className={classes}>{children}</div>;
}
